import { render, staticRenderFns } from "./price_strategy.vue?vue&type=template&id=017ee94f&scoped=true"
import script from "./price_strategy.vue?vue&type=script&lang=js"
export * from "./price_strategy.vue?vue&type=script&lang=js"
import style0 from "./price_strategy.vue?vue&type=style&index=0&id=017ee94f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ee94f",
  null
  
)

export default component.exports